import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { logout } from "../../api/services/authService";
import { useWorkspace } from "../../integrationQA/context/WorkspaceContext";
import "./Logout.css";

function Logout() {
  const navigate = useNavigate();
  const { isAuthenticated, clearSession } = useWorkspace();
  const [loading, setLoading] = useState(false);
  const [loggedOut, setLoggedOut] = useState(false);

  const handleLogout = async () => {
    setLoading(true);
    try { await logout(); } catch (e) { /* the session is cleared locally either way */ }
    clearSession();
    setLoading(false);
    setLoggedOut(true);
  };

  if (loggedOut || !isAuthenticated) {
    return <div className="logout-page"><div className="logout-card"><h2>Signed Out Successfully</h2><p>Your session has ended successfully.</p><button className="login-again-button" onClick={() => navigate("/login")}>Login Again</button></div></div>;
  }

  return (
    <div className="logout-page">
      <div className="logout-card">
        <h2>Sign Out</h2>
        <p>Are you sure you want to sign out?</p>
        <button className="logout-button" onClick={handleLogout} disabled={loading}>{loading ? "Signing out..." : "Sign Out"}</button>
        <button className="deactivate-account-button" onClick={() => navigate("/deactivate-account")}>Deactivate Account</button>
        <button className="cancel-button" onClick={() => navigate("/dashboard")}>Cancel</button>
      </div>
    </div>
  );
}
export default Logout;
